import useBookingModulePermissions from "./use_booking_module_permissions";

export const useIsBookingModulePermitted = () => {
  const { isEnabled, isPermittedToEdit } = useBookingModulePermissions();

  return isEnabled && isPermittedToEdit;
};
